import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LockRegular from './lock-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LockRegular {...validProps} />;
}
SvgComponent.iconName = 'lockRegular';

export const LockRegularIcon = svgIconWrapper(SvgComponent);
